import { Skeleton } from '@/components/atoms/skeleton';

interface EntityListSkeletonRowsProps {
  count?: number;
}

export function EntityListSkeletonRows({ count = 8 }: EntityListSkeletonRowsProps) {
  return (
    <div className="space-y-px p-2">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton key={index} className="h-14 w-full rounded-md" />
      ))}
    </div>
  );
}
